import React from 'react';
import { useTranslator } from '@bluebeam/react-i18n';

interface Props {
  id?: string;
  forAttribute?: string;
  label: string;
  children?: React.ReactNode;
  required?: boolean;
  requiredText?: string;
}

const Label: React.FC<Props> = ({
  id = '',
  children = '',
  required = false,
  requiredText,
  forAttribute,
  label,
}) => {
  const { translate } = useTranslator(['formLabels']);

  return (
    <div
      id={id}
      className="font-size-5 mb2 row justify-between black-2 regular"
    >
      <label htmlFor={forAttribute}>{label}</label>
      <div className="grow-1 pl3">{children}</div>
      {required ? (
        <span className="light color-primary">
          {requiredText || translate('formLabels:required')}
        </span>
      ) : null}
    </div>
  );
};

export default Label;
